import { render, staticRenderFns } from "./WorkTimeCategory.vue?vue&type=template&id=2c27a1f4"
import script from "./WorkTimeCategory.vue?vue&type=script&lang=js"
export * from "./WorkTimeCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c27a1f4')) {
      api.createRecord('2c27a1f4', component.options)
    } else {
      api.reload('2c27a1f4', component.options)
    }
    module.hot.accept("./WorkTimeCategory.vue?vue&type=template&id=2c27a1f4", function () {
      api.rerender('2c27a1f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/register/WorkTimeCategory.vue"
export default component.exports